import { render, staticRenderFns } from "./ExternalPostLinksEditor.vue?vue&type=template&id=2c5135da&scoped=true&"
import script from "./ExternalPostLinksEditor.vue?vue&type=script&lang=js&"
export * from "./ExternalPostLinksEditor.vue?vue&type=script&lang=js&"
import style0 from "./ExternalPostLinksEditor.vue?vue&type=style&index=0&id=2c5135da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5135da",
  null
  
)

export default component.exports